export default __webpack_public_path__ + "static/media/areaHand.d6b57d6c.png";